import { useParams } from 'react-router-dom';
import ProjectItem from './ProjectItem/ProjectItem';
import style from './Projects.module.css';
import { getTranslation, normalizeLang } from '../../../helpers/translation';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getAllProjects } from '../../../api/projectsApi';

const Projects = () => {
  const { lang: rawLang } = useParams();
  const lang = normalizeLang(rawLang);
  const t = useMemo(() => getTranslation(lang), [lang]);

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const topRef = useRef(null);

  useEffect(() => {
    setPage(1);
  }, [lang]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getAllProjects({
      page,
      limit,
      sort: '-createdAt',
      language: lang || 'en',
    })
      .then(data => {
        if (cancelled) return;
        const nTotal = Number(data?.total ?? 0);
        const nLimit = Number(data?.limit ?? limit);
        const nPages = Number(
          data?.pages ?? Math.max(1, Math.ceil(nTotal / Math.max(1, nLimit))),
        );
        setItems(data?.items || []);
        setTotal(nTotal);
        setLimit(nLimit);
        setPages(nPages);
        console.log('BlogPage API ->', {
          page,
          nTotal,
          nLimit,
          nPages,
          count: (data?.items || []).length,
        });
      })
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
  }, [lang, page, limit]);

  return (
    <>
      <div className={style.projectsContainer} id="projects">
        <h1>Our Projects</h1>
        <div className={style.projects}>
          {items.map((item, i) => (
            // Projects.jsx
            <ProjectItem data={item} lang={lang} key={item._id || i} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Projects;
